import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import React, { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import InputMultiRadio from '../Inputs/InputMultiRadio';
import InputChkBox from '../Inputs/InputChkBox';
import FormInputYear from '../Inputs/FormInputYear';

interface IInputProps {
  control: any;
  register: any;
  name: string;
  errors: any;
  disabled?: boolean;
  watch: any;
  setValue: any;
  defaultValue?: any;
}

export const ArrayFieldHijosACargo: React.FC<IInputProps> = ({
  control,
  name,
  register,
  errors,
  disabled,
  watch,
  setValue,
  defaultValue,
}) => {
  const { fields, append, remove } = useFieldArray({ control, name });

  useEffect(() => {
    if (defaultValue) setValue(name, defaultValue);
  }, []);

  return (
    <>
      {fields.map((item, index) => {
        const adoptionYear = watch(`${name}.${index}.HijoAnioAcogimiento`);
        const birthYearReq = adoptionYear
          ? false
          : `Necesita especificar la fecha de nacimiento del Descendiente ${index + 1}`;

        return (
          <div
            key={`${name}.${index}`}
            className="container form--simple-styled"
            id={`${name}.${index}`}
          >
            <div className="row">
              <div className="col-xl-12">
                <FieldsetContainer legend="Datos del Hijo a Cargo" disabled={disabled}>
                  <FormInputYear
                    id={`${name}.${index}.HijoAnioNacimiento`}
                    name={`${name}.${index}.HijoAnioNacimiento`}
                    label="Año de Nacimiento"
                    md={6}
                    xl={6}
                    col={12}
                    req={birthYearReq}
                    maxDate={new Date()}
                    defaultValue={defaultValue?.[index]?.HijoAnioNacimiento ?? null}
                  />
                  <FormInputYear
                    id={`${name}.${index}.HijoAnioAcogimiento`}
                    name={`${name}.${index}.HijoAnioAcogimiento`}
                    label="Año de Acogimiento/Adopción"
                    md={6}
                    xl={6}
                    col={12}
                    maxDate={new Date()}
                    defaultValue={defaultValue?.[index]?.HijoAnioAcogimiento ?? null}
                  />
                  <InputMultiRadio
                    errors={errors}
                    register={register}
                    opciones={['0', '1', '2']}
                    labels={[
                      'Sin Discapacidad',
                      'Superior o igual al 33% e Inferior al 65%',
                      'Superior igual al 65%',
                    ]}
                    name={`${name}.${index}.HijoDiscapacidad`}
                    id={`${name}.${index}.HijoDiscapacidad`}
                    required="Necesita especificar la discapacidad"
                    label="Discapacidad"
                  />
                  <InputChkBox
                    id={`${name}.${index}.HijoAyudaTerceraPersona`}
                    name={`${name}.${index}.HijoAyudaTerceraPersona`}
                    label="Tengo acreditada la necesidad de ayuda de terceras personas o movilidad reducida"
                    col={12}
                    xl={12}
                    md={12}
                    errors={errors}
                    register={register}
                    placeholder={''}
                  />
                  <InputChkBox
                    id={`${name}.${index}.HijoComputoEntero`}
                    name={`${name}.${index}.HijoComputoEntero`}
                    label="Computo por Entero"
                    modal={`En caso de hijos que convivan únicamente con Vd., sin 
convivir también con el otro progenitor (padre o madre), o de 
nietos que convivan únicamente con Vd., sin convivir también 
con ningún otro de sus abuelos, indíquelo marcando la casilla`}
                    col={12}
                    xl={12}
                    md={12}
                    errors={errors}
                    register={register}
                    placeholder={''}
                  />
                  <button
                    id={`btnDelete${index}`}
                    type="button"
                    onClick={() => remove(index)}
                    className="btn-box btn-secondary"
                  >
                    Borrar Hijo a Cargo
                  </button>
                </FieldsetContainer>
              </div>
            </div>
          </div>
        );
      })}
      <button
        className="mt-2 btn-box btn-accent"
        type="button"
        disabled={disabled}
        onClick={() =>
          append({
            HijoAnioNacimiento: null,
            HijoAnioAcogimiento: null,
            HijoDiscapacidad: '0',
            HijoAyudaTerceraPersona: false,
            HijoComputoEntero: false,
          })
        }
      >
        Añadir Hijo a Cargo
      </button>
    </>
  );
};

export default ArrayFieldHijosACargo;
